import { Line } from "@ant-design/plots";
import { Empty } from "antd";
import React from "react";
import { getNoChartIcon } from "../../../util/image";

const LineChart = ({ chartData = [], hoverLabel = "" }) => {
  const maxValue = Math.max(...chartData.map((d) => d?.count), 0);
  console.log(maxValue, chartData);
  const config = {
    data: {
      value: chartData,
      transform: [
        {
          type: "fold",
          fields: ["count"],
          key: "type",
          value: "value",
        },
      ],
    },
    scale: {
      y: {
        domainMin: 0,
        domainMax: maxValue + maxValue * 0.1,
        tickCount: maxValue <= 5 ? maxValue + 1 : undefined,
      },
    },
    xField: "date",
    yField: "count",
    color: "#EC4899",
    xAxis: {
      label: { autoHide: true },
    },
    axis: {
      x: { labelAutoHide: "greedy" },
      y: { 
        labelAutoHide: "greedy",
        tick: true,
        tickCount: maxValue <= 10 ? maxValue + 1 : undefined,
      },
    },
    yAxis: {
      tickCount: maxValue <= 10 ? maxValue + 1 : undefined,
      label: {
        formatter: (value) => Math.round(value).toString(),
      },
    },
    legend: false,
    shapeField: "smooth",
    height: 350,
    tooltip: {
      title: "date",
      items: [
        {
          field: "difference",
          name: hoverLabel,
          valueFormatter: (value) => value || 0,
        },
      ],
    },
  };

  if (maxValue === 0) {
    return (
      <div className="h-[315px] flex items-center justify-center w-full">
        <Empty image={getNoChartIcon()} description="No Stats" />
      </div>
    );
  }

  return <Line {...config} />;
};

export default LineChart;
